import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  Divider,
  Stack
} from '@mui/material';

import 'dayjs/locale/ko';

import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';
import PartnerModalConatiner from '../../../containers/common/form/modal/PartnerModalConatiner';
import FormLabel from '../../common/form/FormLabel';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import * as dayjs from 'dayjs';

const ChanceDetailForm = ({ formik, chance }) => {
  const [expDay, setExpDay] = useState(null);
  const [ordrEstDate, setOrdrEstDate] = useState(null);

  useEffect(() => {
    if (chance) {
      if (chance.expDay) {
        setExpDay(dayjs(chance.expDay));
      }
      if (chance.ordrEstDate) {
        setExpDay(dayjs(chance.ordrEstDate));
      }
    }
    
  }, [chance]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  // Vendor 
  const [openVendor, setOpenVendor] = useState(false);
  const handleOpenVendor = () => {
    setOpenVendor(true);
  };
  const handleCloseVendor = () => {
    setOpenVendor(false);
  };

  const selectedVendor = (partner) => {
    formik.setFieldValue('vendorCmp', partner.partnerUuid);
    formik.setFieldValue('vendorCmpNm', partner.partnerNm);
  };

  // Customer 
  const [openCustomer, setOpenCustomer] = useState(false);
  const handleOpenCustomer = () => {
    setOpenCustomer(true);
  };
  const handleCloseCustomer = () => {
    setOpenCustomer(false);
  };

  const selectedCustomer = (partner) => {
    formik.setFieldValue('customerUuid', partner.partnerUuid);
    formik.setFieldValue('customerNm', partner.partnerNm);
  };

  // Employee
  const [openEmp, setOpenEmp] = useState(false);
  const [title, setTitle] = useState('사원찾기');
  const openEmpModal = (type, title) => {
    setTitle(title);
    setOpenEmp(true);
  };
  const handleEmpClose = () => {
    setOpenEmp(false);
  };

  const selectedEmployee = (emp) => {
    formik.setFieldValue(`crtNm`, emp.usrNm, true);
    formik.setFieldValue(`crtUsr`, emp.usrUuid, false);
  };

  // 필수 필드 마크
  const requiredMark = (
    <Typography
      variant="subtitle2"
      component="span"
      sx={{ ml: 0.5, color: 'error.main' }}
    >
      *
    </Typography>
  );

  // 섹션 헤더 컴포넌트
  const SectionHeader = ({ title }) => (
    <Typography 
      variant="h6" 
      sx={{ 
        mb: 2, 
        fontWeight: 'medium',
        borderBottom: '2px solid',
        borderColor: 'primary.main',
        paddingBottom: 0.5,
        display: 'inline-block'
      }}
    >
      {title}
    </Typography>
  );

  return (
    <div>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <SectionHeader title="프로젝트 기본 정보" />
        
        {/* 첫 번째 행: 프로젝트 타입 (거래처 유형 필드는 0425 p22/0515 p33 시안으로 제거, DB 컬럼은 유지) */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <FormLabel>프로젝트 타입{requiredMark}</FormLabel>
            <BaseCodeSelectbox
              formik={formik}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'PRJ_TYP',
                useYn: 'Y',
              }}
              name="prjTyp"
              size="small"
              required={true}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* 두 번째 행: 사업명, 프로젝트 중요도 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <FormLabel>사업명{requiredMark}</FormLabel>
            <TextField
              size="small"
              required={true}
              variant="outlined"
              fullWidth
              id="cstNm"
              name="cstNm"
              value={formik.values.cstNm}
              onChange={formik.handleChange}
              error={formik.touched.cstNm && Boolean(formik.errors.cstNm)}
              helperText={formik.touched.cstNm && formik.errors.cstNm}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormLabel>프로젝트 중요도{requiredMark}</FormLabel>
            <BaseCodeSelectbox
              formik={formik}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'PRJ_IMPT',
                useYn: 'Y',
              }}
              name="prjImpt"
              size="small"
              required={true}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* 세 번째 행: 예산여부, 제품여부, 조달여부 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={4}>
            <FormLabel>예산여부{requiredMark}</FormLabel>
            <BaseCodeSelectbox
              formik={formik}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'BUGET_YN',
                useYn: 'Y',
              }}
              name="bugetYn"
              size="small"
              required={true}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormLabel>제품여부</FormLabel>
            <BaseCodeSelectbox
              formik={formik}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'PRD_YN',
                useYn: 'Y',
              }}
              name="productYn"
              size="small"
              required={false}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormLabel>조달여부</FormLabel>
            <Box sx={{ mt: 1 }}>
              <FormGroup>
                <FormControlLabel
                  id="procurement"
                  name="procurement"
                  label="조달"
                  control={
                    <Checkbox
                      checked={formik.values.procurement}
                      onChange={(event) =>
                        formik.setFieldValue('procurement', event.target.checked)
                      }
                    />
                  }
                />
              </FormGroup>
            </Box>
          </Grid>
        </Grid>

        {/* 네 번째 행: 영업 담당자, 매출 예상일 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <FormLabel>영업 담당자</FormLabel>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                fullWidth
                id="crtNm"
                name="crtNm"
                value={formik.values.crtNm}
                onChange={formik.handleChange}
                error={formik.touched.crtNm && Boolean(formik.errors.crtNm)}
                helperText={formik.touched.crtNm && formik.errors.crtNm}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={() => openEmpModal('', '영업담당자 선택')}
                sx={{ whiteSpace: 'nowrap' }}
              >
                담당자 선택
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormLabel>매출 예상일{requiredMark}</FormLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="expDay"
                name="expDay"
                value={expDay}
                onChange={(newValue) => {
                  setExpDay(newValue);
                  onChangeDate(newValue, 'expDay');
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    required: true,
                    fullWidth: true,
                    error: formik.touched.expDay && Boolean(formik.errors.expDay),
                    helperText: formik.touched.expDay && formik.errors.expDay
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mb: 3 }}>
        
          <Grid item xs={12} md={6}>
            <FormLabel>수주 예상일{requiredMark}</FormLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="expDay"
                name="ordrEstDate"
                value={ordrEstDate}
                onChange={(newValue) => {
                  setExpDay(newValue);
                  onChangeDate(newValue, 'ordrEstDate');
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    required: true,
                    fullWidth: true,
                    error: formik.touched.ordrEstDate && Boolean(formik.errors.ordrEstDate),
                    helperText: formik.touched.ordrEstDate && formik.errors.ordrEstDate
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

      </Paper>

      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <SectionHeader title="거래처 정보" />
        
        {/* 첫 번째 행: 고객사, 매출처 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <FormLabel>고객사</FormLabel>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="customerNm"
                name="customerNm"
                value={formik.values.customerNm}
                error={
                  formik.touched.customerNm && Boolean(formik.errors.customerNm)
                }
                helperText={
                  formik.touched.customerNm && formik.errors.customerNm
                }
              />
              <Button
                color="secondary"
                variant="outlined"
                size="small"
                onClick={handleOpenCustomer}
                sx={{ whiteSpace: 'nowrap' }}
              >
                고객사 선택
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormLabel>매출처</FormLabel>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="vendorCmpNm"
                name="vendorCmpNm"
                value={formik.values.vendorCmpNm}
                error={
                  formik.touched.vendorCmpNm && Boolean(formik.errors.vendorCmpNm)
                }
                helperText={
                  formik.touched.vendorCmpNm && formik.errors.vendorCmpNm
                }
              />
              <Button
                color="secondary"
                variant="outlined"
                size="small"
                onClick={handleOpenVendor}
                sx={{ whiteSpace: 'nowrap' }}
              >
                매출처 선택
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* 두 번째 행: 고객명(TEXT) */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <FormLabel>고객명(TEXT)</FormLabel>
            <TextField
              size="small"
              required={true}
              variant="outlined"
              fullWidth
              id="partnerInc"
              name="partnerInc"
              value={formik.values.partnerInc}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerInc && Boolean(formik.errors.partnerInc)
              }
              helperText={formik.touched.partnerInc && formik.errors.partnerInc}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <SectionHeader title="담당자 정보" />
        
        {/* 첫 번째 행: 고객 담당자 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <FormLabel>고객 담당자{requiredMark}</FormLabel>
            <TextField
              size="small"
              required={true}
              variant="outlined"
              fullWidth
              id="chargeNm"
              name="chargeNm"
              value={formik.values.chargeNm}
              onChange={formik.handleChange}
              error={
                formik.touched.chargeNm && Boolean(formik.errors.chargeNm)
              }
              helperText={formik.touched.chargeNm && formik.errors.chargeNm}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormLabel>고객담당자 연락처</FormLabel>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="chargeTel"
              name="chargeTel"
              value={formik.values.chargeTel}
              onChange={formik.handleChange}
              error={
                formik.touched.chargeTel && Boolean(formik.errors.chargeTel)
              }
              helperText={
                formik.touched.chargeTel && formik.errors.chargeTel
              }
            />
          </Grid>
        </Grid>

        {/* 두 번째 행: 담당자 이메일 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <FormLabel>고객담당자 이메일</FormLabel>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="chargeEml"
              name="chargeEml"
              value={formik.values.chargeEml}
              onChange={formik.handleChange}
              error={
                formik.touched.chargeEml && Boolean(formik.errors.chargeEml)
              }
              helperText={
                formik.touched.chargeEml && formik.errors.chargeEml
              }
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <SectionHeader title="추가 정보" />
        
        {/* 참고사항 */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormLabel>참고사항</FormLabel>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="forcastTxt"
              name="forcastTxt"
              multiline
              rows={4}
              value={formik.values.forcastTxt}
              onChange={formik.handleChange}
              error={
                formik.touched.forcastTxt && Boolean(formik.errors.forcastTxt)
              }
              helperText={formik.touched.forcastTxt && formik.errors.forcastTxt}
            />
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, gap: 2 }}>
        <Button
          variant="outlined"
          sx={{ minWidth: '100px' }}
        >
          취소
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={formik.isSubmitting}
          sx={{ minWidth: '100px' }}
        >
          저장
        </Button>
      </Box>

      {openVendor && (
        <PartnerModalConatiner
          link
          title="매출처 선택"
          open={openVendor}
          handleClose={handleCloseVendor}
          selectedPartner={selectedVendor}
        />
      )}
      
      {openCustomer && (
        <PartnerModalConatiner
          link
          title="고객사 선택"
          open={openCustomer}
          handleClose={handleCloseCustomer}
          selectedPartner={selectedCustomer}
        />
      )}

      {openEmp && (
        <EmpModalContainer
          title={title}
          multi={false}
          open={openEmp}
          roleTyp="SALES"
          handleClose={handleEmpClose}
          selectedEmployee={selectedEmployee}
        />
      )}
    </div>
  );
};

export default ChanceDetailForm;